module.exports = __webpack_public_path__ + "img/Temperus_closed.749cb7e5.png";